<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" epub:type="z3998:published-works" id="also-by">
<div class="heading heading-with-title heading-without-image" id="also-by-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also by Rob Sinclair</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">James Ryker Series</span></span></b></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://alsoby.me/r/amazon/B06XWXYWLS?fc=gb&amp;ds=1" target="_blank">The Red Cobra</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://alsoby.me/r/amazon/B071HXXLJB?fc=gb&amp;ds=1" target="_blank">The Black Hornet</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://alsoby.me/r/amazon/B075LGRWN1?fc=gb&amp;ds=1" target="_blank">The Silver Wolf</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://alsoby.me/r/amazon/B07JZBVGP2?fc=gb&amp;ds=1" target="_blank">The Green Viper</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://alsoby.me/r/amazon/B07V3MFX31?fc=gb&amp;ds=1" target="_blank">The White Scorpion</a></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-section-side-screen.svg"/>
</div>
</div>
<p class="ornamental-break-as-text">* * *</p>
</div>
<p class="first first-in-section first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">Ryker Returns Series</span></span></b></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://alsoby.me/r/amazon/B08Z3ZP1TC?fc=gb&amp;ds=1" target="_blank">Renegade</a></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-section-side-screen.svg"/>
</div>
</div>
<p class="ornamental-break-as-text">* * *</p>
</div>
<p class="first first-in-section first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">The Enemy Series</span></span></b></p>
<p class="subsq also-by-content">Dance with the Enemy</p>
<p class="subsq also-by-content">Rise of the Enemy</p>
<p class="subsq also-by-content">Hunt for the Enemy</p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-section-side-screen.svg"/>
</div>
</div>
<p class="ornamental-break-as-text">* * *</p>
</div>
<p class="first first-in-section first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">The Sleeper 13 Series</span></span></b></p>
<p class="subsq also-by-content">Sleeper 13</p>
<p class="subsq also-by-content">Fugitive 13</p>
<p class="subsq also-by-content">Imposter 13</p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-section-side-screen.svg"/>
</div>
</div>
<p class="ornamental-break-as-text">* * *</p>
</div>
<p class="first first-in-section first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">The DI Dani Stephens Series</span></span></b></p>
<p class="subsq also-by-content">The Essence of Evil</p>
<p class="subsq also-by-content">The Rules of Murder</p>
<p class="subsq also-by-content">Echoes of Guilt</p>
<p class="subsq also-by-content">The Bonds of Blood</p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-section-side-screen.svg"/>
</div>
</div>
<p class="ornamental-break-as-text">* * *</p>
</div>
<p class="first first-in-section first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">Standalone Thrillers</span></span></b></p>
<p class="subsq also-by-content">Dark Fragments</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsobyrobsinclair.vue?e48ea6be